import * as React from 'react';
import Button from './Button';

interface TimerButtonProps {
  children: React.ReactNode;
  initialSeconds?: number;
  onTimerComplete?: () => void;
  countdownText?: (seconds: number) => string;
  [key: string]: any; // Allow any other Button props
}

const TimerButton: React.FC<TimerButtonProps> = ({
  initialSeconds = 30,
  onTimerComplete,
  children,
  countdownText = (seconds) => `${children} (${seconds}s)`,
  ...buttonProps
}) => {
  const [secondsLeft, setSecondsLeft] = React.useState(initialSeconds);
  const [isTimerActive, setIsTimerActive] = React.useState(true);

  React.useEffect(() => {
    if (secondsLeft > 0 && isTimerActive) {
      const timer = setTimeout(() => {
        setSecondsLeft(secondsLeft - 1);
      }, 1000);

      return () => clearTimeout(timer);
    } else if (secondsLeft === 0 && isTimerActive) {
      setIsTimerActive(false);
      onTimerComplete?.();
    }
  }, [secondsLeft, isTimerActive, onTimerComplete]);

  const isDisabled = isTimerActive;
  const buttonText = isTimerActive ? countdownText(secondsLeft) : children;

  return (
    <Button
      {...buttonProps}
      disabled={isDisabled}
      aria-live="polite"
      aria-atomic="true"
    >
      {buttonText}
    </Button>
  );
};

export default TimerButton;
